import { calculateFinances, UserData, calculateSipFutureValue, formatRupeeLiteral } from '../../../constants';

const MutualFunds = {
  label: 'Mutual Fund Investments',
  sections: [
    {
      type: 'text',
      text: (user: UserData) => {
        const taxData = calculateFinances(user);
        return `
        <h5>
          How? Invest Rs. ${taxData.sipAmount.toLocaleString(
            'en-IN'
          )} monthly in Mutual Funds suggested by ClearTax.
          Make up to Rs. ${formatRupeeLiteral(
            Math.round(taxData.aggressivePlan)
          )} in ${
          taxData.aggressiveYears
          } years.<br /><small class="light">(Calculated at @${
          taxData.aggressivePercent
          }% returns per year)</small></h5>`;
      },
    },
    {
      type: 'text',
      text: (user: UserData) => {
        const taxData = calculateFinances(user);
        const data8 = calculateSipFutureValue(taxData.sipAmount, 8, 15);
        const data16 = calculateSipFutureValue(taxData.sipAmount, 16, 15);
        const data25 = calculateSipFutureValue(taxData.sipAmount, 25, 15);
        return `
          <div class="data-points-graph">
            <img class="full-width" src="https://assets1.cleartax-cdn.com/clearsave/images/g1.svg" />
            <div class="graph-data-8">${formatRupeeLiteral(data8)}</div>
            <div class="graph-data-16">${formatRupeeLiteral(data16)}</div>
            <div class="graph-data-25">${formatRupeeLiteral(data25)}</div>
            <div class="graph-prediction">
              <div class="top-box">
                <div class="left-box">
                  <label>Total Investment</label>
                  <p>${formatRupeeLiteral( taxData.sipAmount * 12 * taxData.aggressiveYears )}</p>
                </div>
                <div class="middle-arrow">
                  <img src="https://assets1.cleartax-cdn.com/clearsave/images/right-green-arrow.svg" />
                </div>
                <div class="right-box">
                  <label>You get</label>
                  <p>${formatRupeeLiteral(data25)}</p>
                </div>
              </div>
              <div class="bottom-box">Your Profit ${formatRupeeLiteral( data25 - taxData.sipAmount * 12 * taxData.aggressiveYears )}</div>
            </div>
          </div>
        `;
      },
    },
  ],
};

export default MutualFunds;



// WEBPACK FOOTER //
// ./components/recommendation/cards/mutualFunds.ts